import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { EntityId } from '@reduxjs/toolkit';
import { Stack, Button } from '@mui/material';
import { CustomTable } from '../../../common/custom-table';
import { ColumnEntity } from '../../../common/custom-table/Table.entities';
import { useAppDispatch } from '../../../../../_config/react/useAppDispatch';
import ParamServerActionsCell from './ParamServerActionsCell';
import { selectAllserveurTypes } from '../../../../core/serveur-type/selectors';
import { deleteOneserveurType, retrieveAllserveurType } from '../../../../core/serveur-type/use-cases';
import { serveurType } from '../../../../core/serveur-type/entities';
import ConfirmationDialog from '../../../common/modals/components/ConfirmationDialog';
import { setSuccess } from '../../../../core/notification/notification.slice';
import useDocumentTitle from '../../../../../_config/react/useDocumentTitle';
import ParamServerAddDialog from './ParamServerAddDialog';

const ParamServer = () => {

    // useDocumentTitle - Does not work properly?
    useDocumentTitle('MTTP - PARAMETRES SERVEUR');

    const [isLoading, setIsLoading] = useState(true);
    const [typeDialogOpen, setTypeDialogOpen] = useState(false);
    const [typeId, setTypeId] = useState('');
    const [deleteButtonLoading, setDeleteButtonLoading] = useState(false);
    const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
    const [initialValues, setInitialValues] = useState({
        name: '',
        value: ''
    });

    const dispatch = useAppDispatch();
    const serveurTypes = useSelector(selectAllserveurTypes);

    useEffect(() => {
        dispatch(retrieveAllserveurType())
            .then(() => setIsLoading(false));

        return () => {
            setIsLoading(true);
        };
    }, [dispatch, setIsLoading]);

    const onRowDoubleClick = (values: serveurType) => {
        const { _id, ...otherProps } = values;
        setTypeId(values._id);
        setInitialValues(otherProps);
        setTypeDialogOpen(true);
    };

    const onSelectRows = () => {
    };

    const onClickEdit = (id: EntityId) => {
        let typeById = serveurTypes.find((t) => t._id === id);
        if ( typeById ) {
            const { _id, ...otherProps } = typeById;
            setTypeId(_id);
            setInitialValues(otherProps);
        }

        setTypeDialogOpen(true);
    };

    const onClickDelete = (id: string) => {
        setConfirmationDialogOpen(true);
        setTypeId(id);
    };

    const onConfirmDeleteDialog = async () => {
        const res: any = await dispatch(deleteOneserveurType(typeId));
        setDeleteButtonLoading(true);
        if ( !res.error ) {
            dispatch(setSuccess(`Le paramètre a bien été supprimé`));
            setConfirmationDialogOpen(false);
        }
        setDeleteButtonLoading(false);
        setTypeId('');
    };

    const onCloseTypeDialog = () => {
        setTypeId('');
        setTypeDialogOpen(false);
        setTimeout(() => {
            setInitialValues({ name: '', value: '' });
        }, 200);
    };

    const columns: ColumnEntity[] = [
        { field: 'name', headerName: 'Clef', width: 120, sortable: true, resizable: true },
        { field: 'value', headerName: 'Valeur', width: 320, sortable: true, resizable: true }
    ];

    const table_serveurTypes = JSON.parse(JSON.stringify(serveurTypes));

    table_serveurTypes.forEach((serveur:any) => {
       
        if(serveur.isDefault === true) {
            serveur.isDefaultString = "Oui";
        }
        else { serveur.isDefaultString = ""; }
        
    });

    return (
        <>
            <Stack direction="row" gap={6}>
            <Stack direction="column" gap={2}>
                    <Button variant="outlined" color="primary" onClick={() => setTypeDialogOpen(true)}>
                        Ajouter
                    </Button>
                </Stack>
<ConfirmationDialog
                title="Supprimer le paramètre"
                contentText="Êtes-vous sûr de vouloir supprimer ce paramètre ?"
                isButtonLoading={deleteButtonLoading}
                open={confirmationDialogOpen}
                onConfirm={onConfirmDeleteDialog}
                onClose={() => {
                    setTypeId('');
                    setConfirmationDialogOpen(false);
                }}
            />
                <CustomTable
                    data={table_serveurTypes}
                    columns={columns}
                    loading={isLoading}
                    hover={false}
                    width={600}
                    onRowDoubleClick={onRowDoubleClick}
                    onSelectRows={onSelectRows}
                    renderActionCell={(rowData, measuredRef) => (
                        <ParamServerActionsCell id={rowData._id} measuredRef={measuredRef} onClickEdit={onClickEdit}
                                             onClickDelete={onClickDelete}/>
                    )}
                />
                
            </Stack>
            <ParamServerAddDialog
                open={typeDialogOpen}
                onCloseDialog={onCloseTypeDialog}
                initialValues={initialValues}
                typeId={typeId}
            />
            
        </>
    );
};
/*

<Stack direction="column" gap={2}>
                    <Button variant="outlined" color="primary" onClick={() => setTypeDialogOpen(true)}>
                        Ajouter
                    </Button>
                </Stack>
<ConfirmationDialog
                title="Supprimer le paramètre"
                contentText="Êtes-vous sûr de vouloir supprimer ce paramètre ?"
                isButtonLoading={deleteButtonLoading}
                open={confirmationDialogOpen}
                onConfirm={onConfirmDeleteDialog}
                onClose={() => {
                    setTypeId('');
                    setConfirmationDialogOpen(false);
                }}
            />
*/
export default ParamServer;
